import { IConfigurationToggles } from 'models';
import { REFERRAL_ENABLED } from 'models/referral/referral.model';

const DEVELOPMENT = process.env.NODE_ENV === 'development';

const isReferral = (toggles: IConfigurationToggles): boolean =>
    !!((DEVELOPMENT && REFERRAL_ENABLED) || toggles.enableReferral);

export { isReferral };
